import { axios } from '@/utils/request'

const api = {
  cateTreeList: '/adminapi/course/cateTreeList',
  cateList: '/adminapi/course/cateList',
  cateAdd: '/adminapi/course/cateAdd',
  cateEdit: '/adminapi/course/cateEdit',
  cateDelete: '/adminapi/course/cateDelete',
  cateDetail: '/adminapi/course/cateDetail',
  setCateRank: '/adminapi/course/setCateRank',
  courseList: '/adminapi/course/courseList',
  courseDetail: '/adminapi/course/courseDetail',
  courseEdit: '/adminapi/course/courseEdit',
  courseAdd: '/adminapi/course/courseAdd',
  courseDelete: '/adminapi/course/courseDelete',
  itemList: '/adminapi/course/itemList',
  courseOrderList: '/adminapi/course/courseOrderList',

  itemEdit: '/adminapi/course/itemEdit',
  itemAdd: '/adminapi/course/itemAdd',
  itemDelete: '/adminapi/course/itemDelete',
  itemDetail: '/adminapi/course/itemDetail',
  setItemRank: '/adminapi/course/setItemRank',
  setCourseRank: '/adminapi/course/setCourseRank',
}

export default api

export function getCateTreeList(parameter) {
  return axios({
    url: api.cateTreeList,
    method: 'get',
    params: parameter
  })
}
export function getCateList(parameter) {
  return axios({
    url: api.cateList,
    method: 'get',
    params: parameter
  })
}
export function addCate(parameter) {
  return axios({
    url: api.cateAdd,
    method: 'post',
    data: parameter
  })
}
export function setCateRank(parameter) {
  return axios({
    url: api.setCateRank,
    method: 'post',
    data: parameter
  })
}
export function editCate(parameter) {
  return axios({
    url: api.cateEdit,
    method: 'post',
    data: parameter
  })
}
export function deleteCate(parameter) {
  return axios({
    url: api.cateDelete,
    method: 'post',
    data: parameter
  })
}
export function getCateDetail(parameter) {
  return axios({
    url: api.cateDetail,
    method: 'get',
    params: parameter
  })
}


export function getCourseList(parameter) {
  return axios({
    url: api.courseList,
    method: 'get',
    params: parameter
  })
}
export function getCourseDetail(parameter) {
  return axios({
    url: api.courseDetail,
    method: 'get',
    params: parameter
  })
}



export function addCourse(parameter) {
  return axios({
    url: api.courseAdd,
    method: 'post',
    data: parameter
  })
}
export function editCourse(parameter) {
  return axios({
    url: api.courseEdit,
    method: 'post',
    data: parameter
  })
}



export function getCourseItemList(parameter) {
  return axios({
    url: api.itemList,
    method: 'get',
    params: parameter
  })
}

export function getCourseOrderList(parameter) {
  return axios({
    url: api.courseOrderList,
    method: 'get',
    params: parameter
  })
}


export function addItem(parameter) {
  return axios({
    url: api.itemAdd,
    method: 'post',
    data: parameter
  })
}
export function editItem(parameter) {
  return axios({
    url: api.itemEdit,
    method: 'post',
    data: parameter
  })
}


export function deleteItem(parameter) {
  return axios({
    url: api.itemDelete,
    method: 'post',
    data: parameter
  })
}


export function deleteCourse(parameter) {
  return axios({
    url: api.courseDelete,
    method: 'post',
    data: parameter
  })
}



export function setCourseRank(parameter) {
  return axios({
    url: api.setCourseRank,
    method: 'post',
    data: parameter
  })
}

export function setItemRank(parameter) {
  return axios({
    url: api.setItemRank,
    method: 'post',
    data: parameter
  })
}



export function getItemDetail(parameter) {
  return axios({
    url: api.itemDetail,
    method: 'get',
    params: parameter
  })
}